export enum FilterBy {
  LastDay = "Ontem",
  Last7Days = "Últimos 7 dias",
  Last15Days = "Últimos 15 dias",
  LastMonth = "Último mês",
}
